export type TranslationMessages = Record<string, string>;

const TRANSLATION_LANGUAGES = [
  'de',
  'en-US',
  'es',
  'fr',
  'he',
  'hu',
  'it',
  'ka',
  'kk',
  'pl',
  'pt',
  'ro',
  'ru',
  'uk',
] as const;

export type TranslationLanguage = (typeof TRANSLATION_LANGUAGES)[number];

const LANGUAGE_ALIASES: Record<string, TranslationLanguage> = {
  en: 'en-US',
  'en-GB': 'en-US',
  'pt-BR': 'pt',
};

const isTranslationLanguage = (language: string): language is TranslationLanguage =>
  (TRANSLATION_LANGUAGES as readonly string[]).includes(language);

export const resolveTranslationLanguage = (
  language: string,
): TranslationLanguage | undefined => {
  const resolved = LANGUAGE_ALIASES[language] ?? language;

  return isTranslationLanguage(resolved) ? resolved : undefined;
};
